import './Footer.css';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <a
          href="https://lovinmalta.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit Lovin Malta"
        >
          <img
            src="/assets/lovin-malta-logo.png"
            alt="Lovin Malta"
            className="site-footer__logo"
          />
        </a>
      </div>
    </footer>
  );
}
